export default __webpack_public_path__ + "images/team-card-banner.png";